export enum QUERY_KEYS_MECHANIZATION {
  getMechanizations = "MECHANIZATION_LIST_GET",
  getSensors = "SENSORS_GET",
  getSpeedChangesChartData = "SPEED_CHANGES_CHART_DATA_GET",
  postTrackerDeviceCode = "TRACKER_DEVICE_CODE_POST",
  updateTrackerDeviceCode = "TRACKER_DEVICE_CODE_PUT",
  deleteTrackerDeviceCode = "TRACKER_DEVICE_CODE_DELETE",
  verifyPhoneNumber = "VERIFY_PHONE_NUMBER_POST",
  getQuestions = "GET_QUESTIONS",
  createMechanization = "CREATE_MECHANIZATION",
  getMechanization = "MECHANIZATION_GET",
  getMovementChanges = "MOVEMENT_CHANGE_GET",
  getTemperatureChanges = "TEMPERATURE_CHANGE_GET",
  getFuelConsumptionChanges = "FUEL_CONSUMPTION_CHANGE_GET",
  deleteMechanization = "DELETE_MECHANIZATION",
}

export enum QUERY_KEYS_CROPPING_PATTERN {
  getCroppingPatterns = "CROPPING_PATTERNS_GET",
}

export enum QUERY_KEYS_CROPPING_SUITABILITY {
  getCroppingSuitabilities = "CROPPING_SUITABILITIES_GET",
}

export enum QUERY_KEYS_EXPERIMENT {
  getExperimentsList = "EXPERIMENTS_LIST_GET",
}

export enum QUERY_KEYS_STATICS {
  getPlantsTypeList = "PLANTS_TYPE_LIST_GET",
}

export enum QUERY_KEYS_PRODUCTS {
  getProductsTypeList = "PRODUCTS_TYPE_LIST_GET",
}

export enum QUERY_KEYS_CROPPING_PATTERN {
  getOneCroppingPattern = "CROPPING_PATTERN_GET",
}

export enum QUERY_KEYS_CROPPING_SUITABILITY {
  getOneCroppingSuitability = "CROPPING_SUITABILITY_GET",
}

export enum QUERY_KEYS_IRIIGATION_SOURCE {
  getIrrigationSources = "IRRIGATION_SOURCES_LIST_GET",
  getIrrigationSource = "IRRIGATION_SOURCE_GET",
  postTrackerDeviceCode = "TRACKER_DEVICE_CODE_POST",
  updateTrackerDeviceCode = "TRACKER_DEVICE_CODE_PUT",
  deleteTrackerDeviceCode = "TRACKER_DEVICE_CODE_DELETE",
  getSensors = "SENSORS_GET",
  getEngineVibrationLevelChangesData = "ENGINE_VIBRATION_LEVEL_CHANGES_GET",
  getStatePowerChangesData = "STATE_POWER_CHANGES_GET",
  getStatePumpChagnesDate = "STATE_PUMP_CHANGES_GET",
  getConsumptionApmsChangesData = "CONSUMPTION_APMS_CHANGES_GET",
}